"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
exports.isSSR = () => {
    return !!!(typeof window !== undefined &&
        window.document &&
        window.document.createElement);
};
exports.checksRedirect = location => {
    return (dispatch, getState, API) => __awaiter(this, void 0, void 0, function* () {
        const { pathname, search } = location;
        try {
            const redirectsData = yield API.checkRedirect({
                url: `${pathname}${search || ''}`,
            });
            if (redirectsData) {
                if (!exports.isSSR()) {
                    window.location.replace(redirectsData.newUrl);
                }
                dispatch(exports.setRedirect(redirectsData.newUrl, redirectsData.redirectCode));
            }
        }
        catch (e) {
            console.error(e);
        }
    });
};
exports.setRedirect = (url, status = 302) => {
    return {
        type: constants_1.REDIRECT,
        payload: {
            url,
            status,
        },
    };
};
